import React, { useContext, useEffect, useMemo, useState } from "react";
import Table from "../components/Table";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";

import {
  getAllSchemes,
  addScheme,
  deleteScheme,
  updateScheme,
  updateSchemeStatus,
  syncUpload,
  syncUploadSuccess,
} from "../actions/scheme-action-types";
import { getAllStates, getAllDealers } from "../actions/dealer-action-types";
import { setAuthorize } from "../actions/app-action-types";
import Icon from "../components/Icon";
import { StyledText } from "../components";
import Modal from "../components/Modal";
import ListSelect from "../components/ListSelect";
import { tenentId } from "../constant";
import { Circle } from "../components/Overlay";
import ConfigData from "../config/config-json.json";
import { getFileType } from "../utilities/utilsFunction";
import { AuthContext } from "../utilities/authContext";
import { Typography } from "@mui/material";

const { languageOptions, applicationNames, documentTypes } = ConfigData;

const openUrl = ["video/mp4", "application/pdf", "text/html", null];
const imageMime = [
  "image/png",
  "image/jpeg",
  "image/avif",
  "image/bmp",
  "image/gif",
  "image/svg+xml",
  "image/tiff",
  "image/webp",
  "png",
  "jpeg",
  "jpg",
];

const loaderCss = {
  position: "absolute",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignContent: "center",
  backgroundColor: "rgb(0,0,0,0.3)",
  alignItems: "center",
  zIndex: 99999,
  top: 0,
  left: 0,
};

const Schemes = ({
  allSchemes,
  getAllSchemes,
  addScheme,
  deleteScheme,
  updateScheme,
  updateSchemeStatus,
  getAllDealers,
  getAllStates,
  allStates,
  allDealers,
  visible,
  syncUpload,
  syncObject,
  syncUploadSuccess,
  setAuthorize,
  isUnauthorize,
}) => {
  const history = useHistory();

  const { logout } = useContext(AuthContext);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedScheme, setSelectedScheme] = useState({});
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [showSchemeActiveModal, setShowSchemeActiveModal] = useState(false);
  const [showActiveDeactiveModal, setShowActiveDeactiveModal] = useState(false);
  const [tableDataFilter, setTableDataFilter] = useState([]);

  const [showDocumentType, setShowDocumentType] = useState(false);
  const [selectedDocumetType, setSelectedDocumentType] = useState([
    documentTypes[0],
  ]);
  const [showApplicationName, setShowApplicationName] = useState(false);
  const [selectedApplicationName, setSelectedApplicationName] = useState([
    applicationNames[0],
  ]);
  const [showSyncModal, setShowSyncModal] = useState(false);

  useEffect(() => {
    if (isUnauthorize) {
      setAuthorize();
      history.push("/login");
      localStorage.removeItem("token");
      localStorage.removeItem("LastTokenRefresh");
      localStorage.removeItem("LastLogin");
      logout();
      toast.error("session has expired", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [isUnauthorize]);

  useEffect(() => {
    getAllStates();
    getAllDealers();
    const appName = localStorage.getItem("applicationName");
    const docType = localStorage.getItem("documentType");
    if (appName) {
      setSelectedApplicationName(JSON.parse(appName));
    }
    if (docType) {
      setSelectedDocumentType(JSON.parse(docType));
    }
  }, []);

  const getSchemeStatus = (row) => {
    if (moment(row.row.values.endDate).diff(new Date()) < 0) {
      return { status: "Ended", color: "515353" };
    }
    if (row.value) return { status: "Active", color: "#227700" };
    return { status: "Inactive", color: "#CC0000" };
  };

  const getDocLanguage = (langCode) => {
    try {
      const lang = languageOptions.find((val) => val.value === langCode);
      return lang.label;
    } catch (error) {
      return "";
    }
  };

  const getDocType = (doc) => {
    try {
      const lang = documentTypes.find((val) => val.value === doc);
      return lang.label;
    } catch (error) {
      return "";
    }
  };
  const columns = [
    {
      Header: "Sl No.",
      accessor: "srNo",
      maxWidth: 50,
      style: { textAlign: "center" },
    },
    {
      Header: "Actions",
      accessor: "docID",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ cursor: "pointer" }}>
              <Link to={`/scheme/${row.value}`}>
                <Icon icon={"eye"} />
              </Link>
            </div>
            <div
              style={{
                marginRight: "8px",
                marginLeft: "8px",
                cursor: "pointer",
              }}
            >
              <Link to={`/update-scheme/${row.value}`}>
                <Icon icon="edit" />
              </Link>
            </div>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (row.row.original.status) {
                  setShowSchemeActiveModal(true);
                } else {
                  setSelectedScheme(row.row.original);
                  setShowDeleteModal(true);
                }
              }}
            >
              <Icon icon="delete" />
            </div>
            {getSchemeStatus(row).status === "Ended" ? null : (
              <div
                style={{
                  width: "65px",
                  height: "25px",
                  borderWidth: "1px",
                  borderColor: row.row.original?.status ? "#CC0000" : "#227700",
                  borderStyle: "solid",
                  borderRadius: "5px",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginLeft: "8px",
                }}
                onClick={() => {
                  setSelectedScheme(row.row.original);
                  setShowActiveDeactiveModal(true);
                }}
              >
                <text
                  style={{
                    fontFamily: "Roboto-Regular",
                    fontSize: "12px",
                    color: row.row.original?.status ? "#CC0000" : "#227700",
                  }}
                >
                  {row.row.original?.status ? "Deactivate" : "Activate"}
                </text>
              </div>
            )}
          </div>
        );
      },
      maxWidth: 80,
    },
    {
      Header: "Status",
      accessor: "status",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: getSchemeStatus(row).color,
            }}
          >
            {getSchemeStatus(row).status}
          </text>
        );
      },
    },
    {
      Header: "Start Date",
      accessor: "startDate",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "End Date",
      accessor: "endDate",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Description",
      accessor: "description",
      maxWidth: 200,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "",
      accessor: "preview",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <div
            style={{
              width: "65px",
              height: "25px",
              border: "none",
              borderRadius: "5px",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              backgroundColor: "#DBDBDB",
            }}
            onClick={() => {
              setShowPreviewModal(true);
              setPreviewUrl(row?.row?.original ?? {});
            }}
          >
            <text
              style={{
                fontFamily: "Roboto-Regular",
                fontSize: "12px",
                color: "#060808",
              }}
            >
              Preview
            </text>
          </div>
        );
      },
    },
    {
      Header: "Language",
      accessor: "language",
      maxWidth: 100,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: "#515353",
            }}
          >
            {getDocLanguage(row.row.values.language)}
          </text>
        );
      },
    },
    {
      Header: "Document Name",
      accessor: "docName",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Doc Type",
      accessor: "docType",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: "#515353",
            }}
          >
            {getDocType(row.value)}
          </text>
        );
      },
    },
    {
      Header: "Model",
      accessor: "modelNo",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
  ];

  useEffect(() => {
    const tableDataAll =
      allSchemes?.map((item, index) => ({
        ...item,
        startDate: item.startDate
          ? moment(item.startDate).format("DD-MMM-YY")
          : "-",
        endDate: item.endDate ? moment(item.endDate).format("DD-MMM-YY") : "-",
      })) || [];
    setTableDataFilter(tableDataAll);
  }, [allSchemes]);

  const updateDocuments = () => {
    const appId = selectedApplicationName?.[0]?.value ?? "";
    const documentType = selectedDocumetType?.[0]?.value ?? "";
    getAllSchemes({
      appId: appId,
      tenentId: tenentId,
      docType: documentType,
      language: "",
    });
  };

  useEffect(() => {
    updateDocuments();
  }, [selectedDocumetType, selectedApplicationName]);

  const tableData = useMemo(() => {
    return (
      tableDataFilter?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || []
    );
  }, [tableDataFilter]);

  useEffect(() => {
    if (syncObject?.messages) {
      setShowSyncModal(true);
      updateDocuments();
    }
  }, [syncObject]);

  const handleSync = () => {
    syncUpload();
  };

  const downloadFile = () => {
    window.open(
      "https://customerapppoc.blob.core.windows.net/content/bulkUpload/Bulk_Upload.xlsx",
      "_blank",
      "noopener,noreferrer"
    );
  };
  return (
    <>
      {visible && (
        <div style={loaderCss}>
          <Circle size="Large" />
        </div>
      )}
      <div
        style={{
          paddingTop: "20px",
          paddingLeft: "40px",
          paddingRight: "40px",
          paddingBottom: "90px",
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          color={"#003E85"}
          marginBottom={2}
        >
          {"Document Management"}
        </Typography>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: 238, marginRight: 30 }}>
            <ListSelect
              heading="Document Type"
              defaultOption={
                selectedDocumetType?.length
                  ? selectedDocumetType[0]?.label
                  : "Document Type"
              }
              options={documentTypes}
              selectedOptions={selectedDocumetType}
              showOptions={showDocumentType}
              onClickShow={() => setShowDocumentType(!showDocumentType)}
              onClickOption={(val) => {
                localStorage.setItem("documentType", JSON.stringify([val]));
                setSelectedDocumentType([val]);
                setShowDocumentType(false);
              }}
              singleSelect
            />
          </div>
          <div style={{ width: 238, marginRight: 30 }}>
            <ListSelect
              heading="Application Name"
              defaultOption={
                selectedApplicationName?.length
                  ? selectedApplicationName[0]?.label
                  : "Application Name"
              }
              options={applicationNames}
              selectedOptions={selectedApplicationName}
              showOptions={showApplicationName}
              onClickShow={() => setShowApplicationName(!showApplicationName)}
              onClickOption={(val) => {
                localStorage.setItem("applicationName", JSON.stringify([val]));
                setSelectedApplicationName([val]);
                setShowApplicationName(false);
              }}
              singleSelect
            />
          </div>
          <Link
            to={{
              pathname: "/upload-scheme",
              state: {
                selectedDocumetType,
                selectedApplicationName,
              },
            }}
          >
            <div
              style={{
                backgroundColor: "#003E85",
                padding: "13px",
                paddingLeft: "16px",
                paddingRight: "16px",
                cursor: "pointer",
                display: "flex",
              }}
            >
              <text className={"document-add"}>DOCUMENT</text>
              <Icon icon="addCircle" />
            </div>
          </Link>
          <div>
            <div
              style={{
                backgroundColor: "#003E85",
                padding: "13px",
                paddingLeft: "16px",
                paddingRight: "16px",
                cursor: "pointer",
                display: "flex",
                marginLeft: "20px",
              }}
              title="Bulk Upload Format"
              onClick={downloadFile}
            >
              <text className={"document-add"}>Bulk Upload Format</text>
            </div>
          </div>
          <div>
            <div
              style={{
                backgroundColor: "#003E85",
                padding: "13px",
                paddingLeft: "16px",
                paddingRight: "16px",
                cursor: "pointer",
                display: "flex",
                marginLeft: "20px",
              }}
              onClick={handleSync}
            >
              <text className={"document-add"}>SYNC</text>
            </div>
          </div>
        </div>
        <Table
          loading={false}
          stickyHeader={true}
          columns={columns}
          data={tableData}
          defaultPageSize={10}
          filterSearchTop={"34px"}
          headerZIndex={1}
        />
        {showDeleteModal && (
          <Modal
            onSubmit={() => {
              deleteScheme(selectedScheme.docID);
              setShowDeleteModal(false);
              setSelectedScheme({});
            }}
            confirmTitle={"OK"}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "flex-end",
                cursor: "pointer",
              }}
              onClick={() => setShowDeleteModal(false)}
            >
              <Icon icon="circleClose" />
            </div>
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                marginTop: "31px",
              }}
            >
              <Icon icon="checkIcon" />
            </div>
            <StyledText
              textAlign={"center"}
              width={"100%"}
              viewPadding={"20px 0px"}
            >
              {"Are you sure? You want to delete the Document."}
            </StyledText>
          </Modal>
        )}
        {showSchemeActiveModal && (
          <Modal
            onSubmit={() => {
              setShowSchemeActiveModal(false);
            }}
            confirmTitle={"OK"}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "flex-end",
                cursor: "pointer",
              }}
              onClick={() => setShowSchemeActiveModal(false)}
            >
              <Icon icon="circleClose" />
            </div>
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                marginTop: "31px",
              }}
            >
              <Icon icon="checkIcon" />
            </div>
            <StyledText
              textAlign={"center"}
              width={"100%"}
              viewPadding={"20px 0px"}
            >
              {"To Delete a scheme you first need to deactivate it."}
            </StyledText>
          </Modal>
        )}
        {showPreviewModal && (
          <Modal>
            <div
              style={{
                display: "flex",
                alignSelf: "flex-end",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowPreviewModal(false);
                setPreviewUrl({});
              }}
            >
              <Icon icon="circleClose" />
            </div>
            <div
              style={{
                alignSelf: "center",
                display: "flex",
              }}
            >
              <div
                style={{
                  height: "533px",
                  width: "300px",
                  backgroundColor: "#f5f5f5",
                }}
              >
                {imageMime.includes(
                  previewUrl?.contentType || getFileType(previewUrl?.docURL)
                ) ? (
                  <img src={previewUrl?.docURL ?? ""} />
                ) : openUrl.includes(previewUrl?.contentType ?? null) ? (
                  <object
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    type="text/html"
                    data={previewUrl?.docURL ?? ""}
                  ></object>
                ) : (
                  <iframe
                    src={`https://docs.google.com/gview?url=${previewUrl?.docURL ?? ""
                      }&embedded=true`}
                    style={{
                      height: "520px",
                      width: "290px",
                      backgroundColor: "#f5f5f5",
                    }}
                    frameborder="0"
                  ></iframe>
                )}
              </div>
            </div>
          </Modal>
        )}
        {showActiveDeactiveModal && (
          <Modal
            onSubmit={() => {
              const { docID, status } = selectedScheme;
              updateSchemeStatus({ docId: docID, status: !status });
              setShowActiveDeactiveModal(false);
              setSelectedScheme({});
            }}
            confirmTitle={"OK"}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "flex-end",
                cursor: "pointer",
              }}
              onClick={() => setShowActiveDeactiveModal(false)}
            >
              <Icon icon="circleClose" />
            </div>
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                marginTop: "31px",
              }}
            >
              <Icon icon="checkIcon" />
            </div>
            <StyledText
              textAlign={"center"}
              width={"100%"}
              viewPadding={"20px 0px"}
            >
              {"Are You sure for the following action?"}
            </StyledText>
          </Modal>
        )}
        {showSyncModal && (
          <Modal
            onSubmit={() => {
              syncUploadSuccess({});
              setShowSyncModal(false);
            }}
            confirmTitle={"OK"}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                marginTop: "31px",
              }}
            >
              <Icon icon="checkIcon" />
            </div>
            <StyledText
              textAlign={"center"}
              width={"100%"}
              viewPadding={"7px 0px"}
            >
              {syncObject?.messages}
            </StyledText>
            {syncObject?.totalFile !== undefined && (
              <StyledText
                textAlign={"center"}
                width={"100%"}
                viewPadding={"7px 0px"}
              >
                {`Total File: ${syncObject?.totalFile}`}
              </StyledText>
            )}
            {syncObject?.uploadFile !== undefined && (
              <StyledText
                textAlign={"center"}
                width={"100%"}
                viewPadding={"7px 0px"}
              >
                {`Uploaded File: ${syncObject?.uploadFile}`}
              </StyledText>
            )}
            {!!syncObject?.filenotFound?.length && (
              <StyledText
                textAlign={"center"}
                width={"100%"}
                viewPadding={"7px 0px 20px 0px"}
              >
                {`File Not Found: ${syncObject?.filenotFound?.toString?.()}`}
              </StyledText>
            )}
          </Modal>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  app: { visible, isUnauthorize },
  schemes: { allSchemes, syncObject },
  dealers: { allStates, allDealers },
}) => ({
  allSchemes,
  allStates,
  allDealers,
  visible,
  syncObject,
  isUnauthorize,
});

export default connect(mapStateToProps, {
  getAllSchemes: getAllSchemes,
  addScheme: addScheme,
  deleteScheme: deleteScheme,
  updateSchemeStatus: updateSchemeStatus,
  updateScheme: updateScheme,
  getAllDealers: getAllDealers,
  getAllStates: getAllStates,
  syncUpload: syncUpload,
  syncUploadSuccess: syncUploadSuccess,
  setAuthorize,
})(Schemes);
